import { Stack, LoadingOverlay, Text, Button } from '@mantine/core';
import { User, useAuthInfo } from '@propelauth/react';
import { GroupsList } from './groups/GroupsList';
import { useState, useEffect } from 'react';

interface GroupsTabProps {
  accessToken?: string; // Make accessToken optional
  user?: User; // Make user optional
  isVisible?: boolean;
}

// Main component without the HOC
const GroupsTab = ({ accessToken: propToken, user: propUser, isVisible = true }: GroupsTabProps) => {
  // Get auth info directly as a fallback
  const authInfo = useAuthInfo();
  const [token, setToken] = useState<string>(propToken || '');
  const [user, setUser] = useState<User | undefined>(propUser);

  // Try to get the token if it wasn't passed as a prop
  useEffect(() => {
    if (!propToken && authInfo?.accessToken) {
      console.log('[GroupsTab] Using accessToken from useAuthInfo');
      setToken(authInfo.accessToken);
    } else if (propToken) {
      console.log('[GroupsTab] Using accessToken from props');
      setToken(propToken);
    } else {
      console.error('[GroupsTab] No accessToken available from props or useAuthInfo');
    }

    if (!propUser && authInfo?.user) {
      console.log('[GroupsTab] Using user from useAuthInfo');
      setUser(authInfo.user as User);
    } else if (propUser) {
      console.log('[GroupsTab] Using user from props');
      setUser(propUser);
    }
  }, [propToken, propUser, authInfo]);

  // Debug logging
  console.log('[GroupsTab] AccessToken present:', !!token);
  console.log('[GroupsTab] AccessToken length:', token?.length || 0);
  console.log('[GroupsTab] User present:', !!user);

  if (!token || !user) {
    return (
      <Stack className="w-full p-4" align="center" gap="md">
        <Text size="lg" fw={500}>Authentication Issue</Text>
        <Text>Unable to load groups due to missing authentication.</Text>
        <Button onClick={() => window.location.reload()}>Refresh Page</Button>
      </Stack>
    );
  }

  return (
    <Stack className="w-full p-4" style={{ position: 'relative' }}>
      <LoadingOverlay visible={false} />
      <GroupsList
        accessToken={token}
        currentUser={user}
        isVisible={isVisible}
      />
    </Stack>
  );
};

export default GroupsTab; 